// utils/formatAmount.js

export const formatAmount = (value) => {
  if (value === null || value === undefined) return "-";

  const number = parseFloat(value);

  // Zero case
  if (number === 0) return "-";

  const formatted = Math.abs(number).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // Negative → (1,000.00)
  if (number < 0) {
    return `(${formatted})`;
  }

  return formatted;
};